import React, { useContext } from 'react';
import { TextField } from '@material-ui/core';
import { MeetingsContext } from '../../../services/meetings/meetings.context';

export const SearchMeetings = () => {
  const { searchTerm, setSearchTerm } = useContext(MeetingsContext);

  return (
    <TextField
      label='Explore meetings'
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
  );
};
